export enum UNLEASH_TOGGLES {
  GLOBAL_REGISTRATION_TYPE = 'global.registration-type',
  GLOBAL_TICKET_TYPES = 'global.ticket-types',
  MEDIA_INTERACTIVE_URLS_IN_SUMMARY = 'media.interactive-urls-in-summaries',
  MEDIA_SUPPRESS_PROGRESS_TRACKING = 'media.suppress-progress-tracking',
}
